import React, { useContext, useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { axiosKK } from '../../services/networkRequest';
import { UserResponse, UserListResponse } from '../../models/APIModels';
import Moment from 'moment';
import UserContext from '../../contexts/UserContext';
import { Role } from '../../utilities/Role';
import { useApi } from '../../services/useApi';
import Button from '../../components/Button';
import {
  AddButton,
  DataTable,
  DataTableColumn,
  PageHeader,
} from '../../components/admin/Shared';

function AdminUsersListComponent({
  history,
}: RouteComponentProps): JSX.Element {
  const { user: loggedInUser } = useContext(UserContext);

  const { data: users = [], loading } = useApi(
    () => axiosKK.get<UserListResponse>('/users').then(({ data }) => data.users),
    []
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const columns: DataTableColumn<UserResponse>[] = [
    {
      key: 'id',
      label: 'ID',
      width: '80px',
      render: (row) => (
        <Button
          variant="link"
          size="sm"
          className="admin-row-link"
          onClick={() => history.push(`/admin/user/${row.id}`, { user: row })}
        >
          {row.id}
        </Button>
      ),
    },
    {
      key: 'createdAt',
      label: 'Created Date',
      render: (row) => Moment(row.createdAt).format('dddd, MMM Do YYYY'),
    },
    { key: 'firstName', label: 'First Name' },
    { key: 'lastName', label: 'Last Name' },
    { key: 'email', label: 'Email' },
    { key: 'role', label: 'Admin Role' },
  ];

  return (
    <>
      <PageHeader
        title="Admin Management"
        onBack={() => history.push('/admin/dashboard')}
      />
      <section className="admin-all-customers-info">
        {loggedInUser?.role === Role.Admin && (
          <AddButton onClick={() => history.push('/admin/users/create')}>
            Create new admin account
          </AddButton>
        )}

        <DataTable
          columns={columns}
          rows={users}
          keyOf={(row) => row.id}
          loading={loading}
          mobileCard
          emptyMessage="No admin accounts to display."
          loadingMessage="Loading admin accounts…"
        />
      </section>
    </>
  );
}

export default withRouter(AdminUsersListComponent);
